module.exports = __webpack_public_path__ + "img/defaultGroup.7a74df66.svg";